@if (canSwitch()) {
    <div
        class="h-full w-16 bg-[rgb(221_221_221)] dark:bg-[rgb(28_28_28)] rounded-lg flex flex-col items-center gap-1 py-3 box-border"
        data-testid="emea-country-switch"
    >
        <sh-menu-item
            id="emea-country-switch-all"
            label=""
            [attr.aria-label]="'common.general.global' | translate"
            [attr.active]="selectedCountry() === null ? true : null"
            data-testid="emea-country-switch-all"
            (click)="selectCountry(null)"
        >
            <span slot="functions" class="w-full h-full flex items-center justify-center -ml-4">
                <sh-icon icon="globe" size="s" class="text-shui-text-subtle"></sh-icon>
            </span>
        </sh-menu-item>
        <div class="w-2/3 h-px bg-shui-text-disabled my-2"></div>
        <div class="country-list flex-1 min-h-0 w-full overflow-y-auto flex flex-col items-center gap-1">
            @for (country of countries(); track country) {
                <sh-menu-item
                    [id]="'emea-country-switch-' + country.toLowerCase()"
                    label=""
                    [attr.aria-label]="'countries.' + country.toLowerCase() | translate"
                    [attr.active]="selectedCountry() === country ? true : null"
                    [attr.data-testid]="'emea-country-switch-' + country.toLowerCase()"
                    [attr.data-country]="country"
                    (click)="selectCountry(country)"
                >
                    <span slot="functions" class="w-full h-full flex items-center justify-center -ml-4">
                        <img
                            class="w-6 h-6 rounded-full object-cover"
                            src="/assets/images/flags/{{ country.toLowerCase() }}.svg"
                            alt="{{ country }} Flag"
                        />
                    </span>
                </sh-menu-item>
            }
        </div>
        <sh-icon
            role="button"
            tabindex="0"
            button
            icon="sidebar-left"
            size="s"
            aria-label="sidebar"
            aria-expanded="true"
            class="flex items-center justify-center w-10 h-10 shrink-0 mt-2"
            data-testid="emea-country-switch-collapse"
            (click)="collapse()"
            (keydown.enter)="collapse()"
        ></sh-icon>
    </div>

    <sh-tooltip
        target="emea-country-switch-all"
        placement="right"
        variation="short"
        [label]="'common.general.global' | translate"
    ></sh-tooltip>
    @for (country of countries(); track country) {
        <sh-tooltip
            [target]="'emea-country-switch-' + country.toLowerCase()"
            placement="right"
            variation="short"
            [label]="'countries.' + country.toLowerCase() | translate"
        ></sh-tooltip>
    }
}
